var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error"},[_c('div',{staticClass:"error-header"},[_vm._m(0),_c('h1',[_vm._v(_vm._s(_vm.code))])]),_c('div',{staticClass:"error-body"},[_c('b-btn',{attrs:{"variant":"link","href":_vm.referrer}},[_vm._v(_vm._s(_vm.referrer))])],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":require("../../assets/logo_big.svg")}})])
}]

export { render, staticRenderFns }